module.exports = __webpack_public_path__ + "static/media/wrong1.5772096e.gif";